import React, { Component } from "react";
import NetworkDeviceListMobileViewItem from "./NetworkDeviceListMobileViewItem";
import NetworkDeviceActionButtons from "../_components/NetworkDeviceActionButtons";
import DiagnosticModeButton from "../../../../components/DiagnosticModeButton";
import IgnoreScheduleModeButton from "../../../../components/IgnoreScheduleModeButton";
import {Card} from "react-bootstrap";


class NetworkDeviceListMobileView extends Component {
    render() {
        const { data } = this.props;

        return(
            <React.Fragment>
                { data.map((item, idx) => {
                    let diagnosticModeColor = item.diagnosticMode ? "border border-danger" : "";
                    return (
                        <Card key={idx} className={diagnosticModeColor}>
                            <Card.Body>
                                <NetworkDeviceListMobileViewItem key={idx} item={item}/>
                            </Card.Body>
                        </Card>
                    )
                }) }


            </React.Fragment>

    )
    }
}
export default NetworkDeviceListMobileView;
